module.exports = __webpack_public_path__ + "static/media/icon-without.03384d3d.svg";